namespace('IO.Views.FirewallRules', function (exports) {
  'use strict';
  exports.Show = exports.New;
});
